import styled from "styled-components";
import { TextTheme, ButtonTheme, ColorTheme, ShadowTheme, SpacingTheme } from "../globaStyledComponents/globalStyledComponentsStyling";

export const DatePickerSectionWrapper = styled.div`
    position: fixed;
    width: 100%;
    left: 0;
    border-radius: 32px 32px 0 0;
    background: rgba(255, 255, 255, 0.85);
    backdrop-filter: blur(16px);
    bottom: 0;
    margin: 0;
    box-shadow: ${ShadowTheme.shadow_300.boxShadow};
    z-index: 102;
    padding: ${SpacingTheme.spacing_400.padding} ${SpacingTheme.spacing_400.padding} ${SpacingTheme.spacing_300.padding};
    display: flex;
    flex-direction: column;
    height: calc(100dvh - 12px);

    @media (min-width: 768px) {
        width: 560px;
        height: fit-content;
        bottom: 0;
        top: 0;
        left: 0;
        right: 0;
        padding: ${SpacingTheme.spacing_400.padding};
        margin: auto;
        border-radius: 32px;
    }
    @media (min-width: 1280px) {
        width: 800px;
    }
`;

export const DatePickerTitle = styled.h2`
    font-size: ${TextTheme.sans_700_semi.fontSize};
    line-height: ${TextTheme.sans_700_semi.lineHeight};
    margin: 0;
    padding: 8px 0 0 8px;
    font-family: ${TextTheme.sans_700_semi.fontFamily};
    color: hsla(0, 0%, 15%, 1);
`;

export const DatePickerSubtitle = styled.p`
    font-size: ${TextTheme.sans_300.fontSize};
    line-height: ${TextTheme.sans_300.lineHeight};
    margin: 0;
    padding: 8px 0 0 8px;
    font-family: ${TextTheme.sans_300.fontFamily};
    color: ${ColorTheme.Grey.color};
`;

export const DatePickerSectionTitleWrapper = styled.div`
    display: none;
`;

export const DatePickerTitleIconButton = styled.button`
    padding: 0;
    grid-column: 1/2;
    grid-row: 1/2;
    justify-self: flex-start;
    align-self: flex-start;
    background: none;
    border: none;
    cursor: pointer;
`;

export const DatePickerTitleIcon = styled.img`
    width: 16px;
    height: 16px;
`;

export const DatePickerWrapper = styled.div`
    padding-top: 24px;
    position: relative;
    width: 100%;
    flex: 1;
    .date-picker-container {
        height: 100% !important;
        .date-picker-table-container {
            height: 100% !important;
        }
    }
`;

interface DatePickerSectionTitleProps {
    selected: boolean;
}
export const DatePickerSectionTitle = styled.p<DatePickerSectionTitleProps>`
    font-size: ${TextTheme.sans_300_semi.fontSize};
    line-height: ${TextTheme.sans_300_semi.lineHeight};
    font-family: ${TextTheme.sans_300_semi.fontFamily};
    color: ${(props) => (props.selected ? "hsla(0, 0%, 15%, 1)" : "hsla(0, 0%, 41%, 1)")};
    margin: 0;
    padding-bottom: 4px;
`;

export const DatePickerSectionCalendarButtonWrapper = styled.div`
    position: relative;
    margin-top: 32px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;

    @media (min-width: 768px) {
        padding-bottom: 0px;
        margin-top: 0px;
        margin-bottom: 0px;
        align-self: flex-end;
    }
`;

export const DatePickerSectionCalendarBackButton = styled.button`
    margin: 0;
    font-size: ${ButtonTheme.sans_button_200.fontSize};
    line-height: ${ButtonTheme.sans_button_200.lineHeight};
    font-family: ${ButtonTheme.sans_button_200.fontFamily};
    color: hsla(0, 0%, 15%, 1);
    padding-bottom: 4px;
    background: none;
    border: none;
    text-decoration: underline;
    cursor: pointer;
    padding: 0;
`;
